import React from 'react'
import { StyledSection } from './mLoaderOverlay.style'
import Loader from 'form/components/atoms/aLoader'

import {
  Breakpoints,
  Layout,
  Container,
  ContainerPadding,
  ContainerWrap
} from '@volkswagen-onehub/components-core'

const LoaderOverlay = () => (
  <StyledSection>
    <Layout
      appearance={{
        [Breakpoints.default]: [
          { name: '.', columns: 2 },
          { name: 'a', columns: 20 },
          { name: '.', columns: 2 }
        ]
      }}
    >
      <Container
        wrap={{
          [Breakpoints.default]: ContainerWrap.always
        }}
        padding={{
          top: {
            [Breakpoints.default]: ContainerPadding.static1200,
            [Breakpoints.tablet]: ContainerPadding.static1000
          },
          bottom: {
            [Breakpoints.default]: ContainerPadding.static1200,
            [Breakpoints.tablet]: ContainerPadding.static1000
          }
        }}
      >
        <Loader />
      </Container>
    </Layout>
  </StyledSection>
)

export default LoaderOverlay
